module.exports = __webpack_public_path__ + "img/instagram.86fd5d84.png";